module.exports = __webpack_public_path__ + "static/img/newanli-02.fef4190c.png";